// extracted by mini-css-extract-plugin
module.exports = {"ApproveProducts__collections":"ApproveProducts_ApproveProducts__collections__1ZIoN"};